import { motion } from "framer-motion";

const services = [
  {
    n: "01",
    id: "outbound",
    title: "Outsourced Outbound Sales",
    desc: "Consultative outbound that fills your pipeline with qualified conversations. No recruitment cycle, no salary risk, no months of ramp-up.",
  },
  {
    n: "02",
    id: "consulting",
    title: "Commercial Growth Consulting",
    desc: "A close look at the commercial engine behind your pipeline, so the conversations you start turn into revenue.",
  },
  {
    n: "03",
    id: "enrolment",
    title: "Specialist Outsourced Enrolment Solutions",
    desc: "For training providers and education organisations, turning interest into enrolments.",
  },
  {
    n: "04",
    id: "ai",
    title: "AI Automation, SaaS & Digital Marketing",
    desc: "Full-spec solutions designed around the size of your organisation and where you are heading.",
  },
];

export const Services = () => (
  <section id="services" data-testid="services-section" className="bg-[#F2EDE6] py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="mb-16 max-w-2xl"
      >
        <h2 className="font-heading text-2xl font-semibold tracking-tight text-[#1C1512] sm:text-3xl lg:text-4xl">
          What Ruby Mill <span className="font-display italic text-ruby">does</span>
        </h2>
      </motion.div>

      <div>
        {services.map((s, i) => (
          <motion.div
            key={s.id}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.06, ease: [0.16, 1, 0.3, 1] }}
            data-testid={`service-row-${s.id}`}
            className="grid grid-cols-12 items-baseline gap-4 border-t border-[#1C1512]/10 py-10 last:border-b sm:py-12"
          >
            <span className="col-span-2 font-mono text-sm text-ruby sm:col-span-1">/{s.n}</span>
            <h3 className="col-span-10 font-heading text-xl font-semibold tracking-tight text-[#1C1512] sm:col-span-5 sm:text-2xl">
              {s.title}
            </h3>
            <p className="col-span-10 col-start-3 mt-2 max-w-xl text-base leading-relaxed text-[#5C5248] sm:col-span-6 sm:col-start-7 sm:mt-0">
              {s.desc}
            </p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
